import { Injectable } from '@angular/core';

// import {Observable} from 'rxjs/observable';
import { Observable,Observer } from 'rxjs';

import * as socketIo from 'socket.io-client';
import { environment } from "../../../environments/environment";
@Injectable()
export class SocketService
{
  private BASE_URL = environment.socketURL;
  private socket;

  observer: Observer<number>;

  constructor(){}

  connectSocket(details)
  {
    var socketID = localStorage.getItem("socketID")
    var { _id, email, iat,name } = details;
    // console.log(details);
    
    this.socket = socketIo(this.BASE_URL, { query: `name=${name}&userId=${_id}&userName=${email}_${iat}&iat=${iat}&socketID=${socketID}`});
  }

  disconnectSocket(type)
  {
    this.socket.emit('disconnect', { type});
  }

  getSocketID() : Observable<any>
  {
    if(this.socket)
    {
      this.socket.on('socket-added', (res) =>
      {
        localStorage.setItem("socketID", res.data)
      });
    }
    return this.createObservable();
  }

  logout(userId)
  {
    if (this.socket)
    {
      this.socket.emit('logout', {userId});
    }
  }

  getSocket() : Observable<any>
  {
    if(this.socket)
    {
      this.socket.on('data', (res) =>
      {
        this.observer.next(res.data);
      });
    }
    return this.createObservable();
  }

  createObservable() : Observable<number> 
  {
      return new Observable<number>(observer => {
        this.observer = observer;
      });
  }

  private handleError(error) 
  {
    console.error('server error:', error);
    if (error.error instanceof Error) 
    {
        let errMessage = error.error.message;
        return Observable.throw(errMessage);
    }
    return Observable.throw(error || 'Socket.io server error');
  }
}

interface Socket 
{
  on(event: string, callback: (data: any) => void );
  emit(event: string, data: any);
}